import * as React from 'react';
import { Wrapper, Title, Description, Link } from './styled';
import { ASSESORS } from '@app/src/config/footer';

interface Props {
  className?: string;
}

export const Assesors: React.FC<Props> = ({ className }) =>
  <Wrapper className={className}>
    <Title>Contáctanos</Title>
    {
      ASSESORS &&
      <Description>
        {
          ASSESORS.map((assesor, key) => (
            <li key={key}><Link href={`mailto:${assesor}`}>{assesor}</Link></li>
          ))
        }
      </Description>
    }
    <Description>
      <li></li>
      <li>EMPRESA EDITORA EL COMERCIO S.A</li>
      <li>20143229816</li>
    </Description>
  </Wrapper>
